<template>
  <div class="tw-bg-white tw-rounded-xl tw-border tw-border-gray-200 tw-p-6 tw-shadow-sm">
    <div class="tw-flex tw-items-center tw-gap-3 tw-mb-4">
      <div class="tw-w-10 tw-h-10 tw-bg-green-100 tw-rounded-lg tw-flex tw-items-center tw-justify-center">
        <icon icon="solar:chart-2-bold" class="tw-text-green-600" />
      </div>
      <h3 class="tw-text-lg tw-font-semibold tw-text-gray-800">Session Insights</h3>
    </div>
    
    <div class="tw-space-y-4">
      <div class="tw-flex tw-items-center tw-justify-between tw-p-3 tw-bg-gray-50 tw-rounded-lg">
        <span class="tw-text-sm tw-text-gray-600">Total Duration</span>
        <span class="tw-font-semibold tw-text-gray-800">{{ formattedDuration }}</span>
      </div>
      
      <div v-if="session?.attendees_count" class="tw-flex tw-items-center tw-justify-between tw-p-3 tw-bg-gray-50 tw-rounded-lg">
        <span class="tw-text-sm tw-text-gray-600">Participants</span>
        <span class="tw-font-semibold tw-text-gray-800">{{ session.attendees_count }}</span>
      </div>
      
      <div v-if="session?.speakers && session.speakers.length > 0" class="tw-flex tw-items-center tw-justify-between tw-p-3 tw-bg-gray-50 tw-rounded-lg">
        <span class="tw-text-sm tw-text-gray-600">Speakers</span>
        <span class="tw-font-semibold tw-text-gray-800">{{ session.speakers.length }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import moment from 'moment'

const props = defineProps({
  session: {
    type: Object,
    required: true
  }
})

const formattedDuration = computed(() => {
  if (!props.session?.start_date || !props.session?.end_date) return 'Duration not specified'
  
  try {
    const start = moment(props.session.start_date)
    const end = moment(props.session.end_date)
    const duration = moment.duration(end.diff(start))
    const hours = Math.floor(duration.asHours())
    const minutes = duration.minutes()
    
    if (hours > 0) {
      return `${hours}h ${minutes}m`
    }
    return `${minutes}m`
  } catch (error) {
    console.error('Error calculating duration:', error)
    return 'Duration not specified'
  }
})
</script>
